import { useTranslation } from "react-i18next";
import { useState } from "react";
import Caroussel from "../general/programmeCaroussel";

const importAll = (r) => r.keys().map(r);
const imagesGroupGame = importAll(
  require.context(
    "../../assets/img/caroussel_programme/groupGames", // Chemin vers ton dossier d'images
    false,
    /\.(png|jpe?g|svg|webp)$/
  )
);
const imagesCreaActivity = importAll(
  require.context(
    "../../assets/img/caroussel_programme/creativeActivities", // Chemin vers ton dossier d'images
    false,
    /\.(png|jpe?g|svg|webp)$/
  )
);
const imagesOutdoorActivity = importAll(
  require.context(
    "../../assets/img/caroussel_programme/outdoorActivities", // Chemin vers ton dossier d'images
    false,
    /\.(png|jpe?g|svg|webp)$/
  )
);
const imagesPlayBased = importAll(
  require.context(
    "../../assets/img/caroussel_programme/playBasedApproach", // Chemin vers ton dossier d'images
    false,
    /\.(png|jpe?g|svg|webp)$/
  )
);

const imagesByTab = {
  games: imagesGroupGame,
  manual: imagesCreaActivity,
  outing: imagesOutdoorActivity,
  playful: imagesPlayBased,
};

export default function Programme() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("games");

  const tabs = [
    { key: "games", label: t("programme.tab.games"), color: "yellow" },
    { key: "manual", label: t("programme.tab.manual"), color: "blue" },
    { key: "outing", label: t("programme.tab.outing"), color: "red" },
    { key: "playful", label: t("programme.tab.playful"), color: "green" },
  ];

  const activeColor = tabs.find((t) => t.key === activeTab)?.color || "yellow";

  return (
    <section className="Programme fade">
      <h2>{t("programme.title")}</h2>

      <div className="programme-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`programme-tab ${tab.color} ${
              activeTab === tab.key ? "active" : ""
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={`programme-content ${activeColor}`}>
        <article>
          <h3>{t(`programme.${activeTab}.title`)}</h3>
          <p>{t(`programme.${activeTab}.text1`)}</p>
          <p>{t(`programme.${activeTab}.text2`)}</p>
        </article>

        {/* 🎠 Ton carrousel avec images spécifiques par onglet */}
        <Caroussel images={imagesByTab[activeTab]} />
      </div>
    </section>
  );
}
